import React, { lazy, memo } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import SpecificationFolderContentsRedirectRoute from './SpecificationFolderContentsRedirect';

const Model = lazy(() => import('../views/Model'));
const NoMatch = lazy(() => import('../views/NoMatch'));
const Dashboard = lazy(() => import('../views/SpecificationsDashboard'));
const SpecificationDetails = lazy(() => import('../views/SpecificationDetails'));
const SpecificationVariants = lazy(() => import('../views/SpecificationVariants'));
const SpecificationDocument = lazy(() => import('../views/SpecificationDocument'));

// const ComponentsCost = lazy(() => import('../views/ComponentsCost'));
// const Deadlines = lazy(() => import('../views/Deadlines'));

const SpecificationsRouts = ({ match }) => {
  const { url } = match;

  return (
    <Switch>
      <Route exact path={`${url}`}>
        <SpecificationFolderContentsRedirectRoute url={url} />
      </Route>

      <Route exact path={`${url}/folders/:folderId`}>
        <Dashboard url={url} />
      </Route>

      <Route exact path={`${url}/details_/:modelSpecificationId/variants`}>
        <SpecificationVariants />
      </Route>

      <Route exact path={`${url}/details_/:modelSpecificationId/document`}>
        <SpecificationDocument />
      </Route>

      <Route path={`${url}/details_/:modelSpecificationId`}>
        <Model />
      </Route>

      <Route exact path={`${url}/details/:modelSpecificationId/document`}>
        <SpecificationDocument />
      </Route>
      <Route path={`${url}/details/:modelSpecificationId`}>
        <SpecificationDetails />
      </Route>

      <Redirect
        path={`${url}/details_/:modelSpecificationId/*`}
        to={`${url}/details_/:modelSpecificationId`}
      />

      <Route exact path={`${url}/details_/:modelSpecificationId/*`}>
        <NoMatch />
      </Route>

      {/* <Route exact path={`${url}/:projectId/:modelId/deadlines`}>
        <Deadlines />
      </Route> */}
      {/*
      <Route
        exact
        path={`${url}/:projectId/:modelId/components-cost`}
        render={({ history }) => <ComponentsCost history={history} match={match} />}
      /> */}
    </Switch>
  );
};

export default memo(SpecificationsRouts);
